import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import type { Size } from 'types/size';
import TitleStyling from '../styles/title';
import type { fontSizeTypes } from '../types';
import Text from './Text';

const StyledText = styled(Text)`
    ${TitleStyling};
`;

type TitleTypes = 'span' | 'div' | 'strong' | 'b' | 'h1' | 'h2';
type TitleSize = Extract<Size, 'S' | 'M' | 'L'>;

export interface ITitle extends HTMLAttributes<HTMLSpanElement> {
    as?: TitleTypes;
    size: TitleSize;
}

const titleSizeMap: Record<TitleSize, fontSizeTypes> = {
    S: { xs: 16, lg: 18 },
    M: { xs: 18, lg: 20 },
    L: { xs: 20, lg: 24 }
};

export default function Title(props: ITitle): JSX.Element {
    const { as, size, children, ...restProps } = props;

    return (
        <StyledText forwardedAs={as as any} size={titleSizeMap[size]} {...restProps}>
            {children}
        </StyledText>
    );
}
